<template>
  <div
    class="rooms-container app-border-r"
    :class="{ 'rooms-container-full': isMobile }"
    v-show="showRoomsList"
  >
    <chat-room-header>
      <template v-slot:rooms-header-logo>
        <slot name="rooms-header-logo"></slot>
      </template>
    </chat-room-header>
    <!--        <div class="nav-mobile">-->
    <!--            <div class="nav-mobile__top ">-->
    <!--                <div class="row position-relative">-->
    <!--                    <div class="col-3 nav-mobile__top-left">-->
    <!--                        <button class="button button__icon button__icon&#45;&#45;lightgrey" onclick="goBack()">-->
    <!--                            <i class="demo-icon icon-back"></i>-->
    <!--                        </button>-->
    <!--                    </div>-->
    <!--                    <div class="col-6 nav-mobile__top-center">-->
    <!--                        <router-link :to="{name: 'members'}">-->
    <!--                            &lt;!&ndash; TODO @aran - change icon to slot for logo                  <i class="demo-icon icon-logo-black"></i>&ndash;&gt;-->
    <!--                            <slot name="rooms-header-logo"></slot>-->
    <!--                        </router-link>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

    <SearchBox v-show="rooms.length && searchBoxPlace==='top'" v-model="searchPhrase" :placeholder="textMessages.SEARCH"></SearchBox>

    <slot name="rooms-header"></slot>

    <div class="rooms-container__chat-tabs">
      <button class="button button__tab-secondary button__tab-secondary--left mr-3" :class="{'button__tab-secondary--active':roomsMatched===false}" @click="roomsMatched=false">{{ trans.get('pages:chat.tabs.messages') }}</button>
      <button class="button button__tab-secondary button__tab-secondary--right" :class="{'button__tab-secondary--active':roomsMatched===true}" @click="roomsMatched=true">{{ trans.get('pages:chat.tabs.matches') }}</button>
    </div>

    <SearchBox v-show="rooms.length && searchBoxPlace==='middle'" v-model="searchPhrase" :placeholder="textMessages.SEARCH"></SearchBox>

    <loader :show="loadingRooms"></loader>

    <div v-if="!loadingRooms && !rooms.length" class="rooms-empty">
      <slot name="rooms-empty">
        {{ textMessages.ROOMS_EMPTY }}
      </slot>
    </div>

    <div v-if="!loadingRooms" class="room-list">
      <div
        class="room-item"
        v-for="(room, index) in filteredRooms"
        :key="room.roomId"
        :class="{ 'room-selected': (selectedRoomProfileId === room.profile_id) && !room.is_admin_special, 'room-admin-special': room.profile.is_admin_special }"
        @click="openRoom(room)"
      >
        <slot name="rooms-item" v-bind="{'room': room, 'index': index}">
          <div
            v-if="room.avatar"
            class="room-avatar"
            :style="{ 'background-image': `url('${room.avatar}')` }"
          ></div>
          <div class="name-container text-ellipsis">
            <div class="title-container">
              <div
                v-if="userStatus(room)"
                class="state-circle"
                :class="{ 'state-online': userStatus(room) === 'online' }"
              ></div>
              <div class="room-name text-ellipsis">
                {{ room.roomName }}
              </div>
              <div v-if="room.lastMessage" class="text-date">
                {{ room.lastMessage.timestamp }}
              </div>
            </div>
            <div
              class="text-last"
              :class="{ 'message-new': room.lastMessage.new }"
              v-if="room.lastMessage"
            >
						<span v-if="room.lastMessage.seen">
							<svg-icon name="checkmark" class="icon-check" />
						</span>
              <format-message
                :content="getLastMessage(room)"
                :deleted="!!room.lastMessage.deleted"
                :formatLinks="false"
                :textFormatting="textFormatting"
                :singleLine="true"
              ></format-message>
            </div>
          </div>
        </slot>
      </div>
    </div>

    <slot name="rooms-footer"></slot>
  </div>
</template>

<script>
import Loader from './Loader'
import SvgIcon from './SvgIcon'
import FormatMessage from './FormatMessage'

import filteredUsers from '../utils/filterItems'
import { mapGetters } from "vuex";
import SearchBox from "./SearchBox";

export default {
  name: 'rooms-list',
  components: { SearchBox, Loader, SvgIcon, FormatMessage },
  props: {
    currentUserId: { type: [String, Number], required: true },
    textMessages: { type: Object, required: true },
    showRoomsList: { type: Boolean, required: true },
    showAddRoom: { type: Boolean, required: true },
    textFormatting: { type: Boolean, required: true },
    isMobile: { type: Boolean, required: true },
    rooms: {
      type: Object, default: () => ({
        messages: [],
        matches: [],
        length: 0
      }), required: true
    },
    loadingRooms: { type: Boolean, required: true },
    room: { type: Object, required: true },
    searchBoxPlace: { type: String, default: 'middle' },
  },
  data() {
    return {
      selectedRoomId: '',
      selectedRoomProfileId: '',
      // roomsMatched: false,
      searchPhrase: null,
    }
  },
  computed: {
    filteredRooms: function () {
      let vm = this;

      let rooms = vm.roomsMatched ? this.rooms.matches : this.rooms.messages;

      return filteredUsers(
        rooms,
        'roomName',
        vm.searchPhrase
      );
    },
    roomsMatched: {
      get() {
        return this.$store.getters["chat/getShowMatchedTab"];
      },
      set(value) {
        this.$store.commit('chat/setShowMatchedTab', value);
      },
    },
  },
  watch: {
    room(val) {
      if (val) this.selectedRoomId = val.roomId
      if (val) this.selectedRoomProfileId = val.profile_id
    },
  },
  methods: {
    openRoom(room) {
      if (room.profile_id === this.room.profile_id && !this.isMobile) {
        return;
      }

      this.selectedRoomId = room.roomId

      this.$emit('openRoom', { room, source: 'RoomList' })
    },
    addRoom() {
      this.$emit('addRoom')
    },
    userStatus(room) {
      if (!room.users || room.users.length !== 2) return

      const user = room.users.find(u => u._id !== this.currentUserId)

      if (user.status) return user.status.state
    },
    getLastMessage(room) {
      const content = room.lastMessage.deleted
        ? this.textMessages.MESSAGE_DELETED
        : room.lastMessage.content

      if (room.users.length <= 2) {
        return content
      }

      const user = room.users.find(
        user => user._id === room.lastMessage.sender_id
      )

      if (user._id === this.currentUserId) {
        return content
      }

      return `${user.username} - ${content}`
    }
  }
}
</script>

<style lang="scss" scoped>
.rooms-container {
  display: flex;
  flex-flow: column;
  flex: 0 0 25%;
  min-width: 260px;
  max-width: 500px;
  position: relative;
  background: var(--chat-sidemenu-bg-color);
  height: 100%;
  border-top-left-radius: var(--chat-container-border-radius);
  border-bottom-left-radius: var(--chat-container-border-radius);
}

.rooms-container-full {
  flex: 0 0 100%;
  max-width: 100%;
}

.box-search {
  position: sticky;
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 15px;
}

//.icon-search {
//    display: flex;
//    position: absolute;
//    left: 30px;
//
//    svg {
//        width: 18px;
//        height: 18px;
//    }
//}

//.add-icon {
//    margin-left: auto;
//    padding-left: 10px;
//}

//input {
//    height: 38px;
//    width: 100%;
//    background: var(--chat-bg-color-input);
//    color: var(--chat-color);
//    border-radius: 4px;
//    font-size: 15px;
//    outline: 0;
//    caret-color: var(--chat-color-caret);
//    padding: 10px 10px 10px 40px;
//    border: 1px solid var(--chat-sidemenu-border-color-search);
//    border-radius: 20px;
//
//    &::placeholder {
//        color: var(--chat-color-placeholder);
//    }
//}

//.rooms-empty {
//	font-size: 14px;
//	color: #9ca6af;
//	font-style: italic;
//	text-align: center;
//	margin: 40px 0;
//	line-height: 20px;
//	white-space: pre-line;
//}

.room-list {
  flex: 1;
  position: relative;
  max-width: 100%;
  cursor: pointer;
  padding: 0 10px 5px;
  overflow-y: auto;
}

.room-item {
  border-radius: 8px;
  align-items: center;
  display: flex;
  flex: 1 1 100%;
  margin-bottom: 5px;
  padding: 0 16px;
  position: relative;
  min-height: 71px;

  &:hover {
    background: var(--chat-sidemenu-bg-color-hover);
    transition: background-color 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }

  &:not(:hover) {
    transition: background-color 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }
}

.room-selected {
  color: var(--chat-sidemenu-color-active) !important;
  background: var(--chat-sidemenu-bg-color-active) !important;

  &:hover {
    background: var(--chat-sidemenu-bg-color-active) !important;
  }
}

.name-container {
  flex: 1;
}

.title-container {
  display: flex;
  align-items: center;
  line-height: 25px;
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.room-name {
  flex: 1;
  color: var(--chat-room-color-username);
  font-weight: 500;
}

.text-last {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 17px;
  color: var(--chat-room-color-message);
}

.message-new {
  color: var(--chat-room-color-username);
  font-weight: 500;
}

.text-date {
  margin-left: 5px;
  font-size: 11px;
  color: var(--chat-room-color-timestamp);
}

.icon-check {
  display: flex;
  height: 14px;
  width: 14px;
  margin-top: -2px;
  margin-right: 2px;
}

.state-circle {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: var(--chat-room-color-offline);
  margin-right: 6px;
  transition: 0.3s;
}

.state-online {
  background-color: var(--chat-room-color-online);
}

@media only screen and (max-width: 768px) {
  .box-search {
    height: 58px;
  }

  .room-list {
    padding: 0 7px 5px;
  }

  .room-item {
    min-height: 60px;
    padding: 0 8px;
  }
}
</style>
